import {
  LOGOUT,
} from "../actions/actionTypes";

const initialState = {
};

export default function adminReducer(state = initialState, action) {
  // const {type, payload} = action;
  const {type} = action;
  switch (type) {
    case LOGOUT:
      return {
        ...state,
      };
    default:
      return state;
  }
}
